<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="messageTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
       <template slot="isPublish" slot-scope="data">
         <span class="publish-status" v-if="data.row.isPublish === 1">已发布</span>
         <span v-else>草稿</span>
       </template>
       <template slot="wtFormTableListButtonsAfter" slot-scope="scope">
        <template v-if="scope.row.isPublish !== 1">
          <template v-for="(item, index) in formTableButtonsData">
           <wt-auth class="search-form-btn" v-bind:key="index">
             <el-button size="mini" :type="item.className ? item.className : 'default'" @click="toClickAction(scope.row, item)"
             >{{ item.condition ? item.value[scope.row[item.condition]] : item.name}}</el-button>
           </wt-auth>
          </template>
        </template>
       </template>
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_MESSAGE',
        formComponent: {
          add: { type: 'component', componentName: 'Message-edit', value: 'resetMessageDetailData' },
          edit: { type: 'component', componentName: 'Message-edit', value: 'queryMessageDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/message/messageList' },
          delete: { type: 'default', value: '/modules/message/messageDelete' }
        },
        formInputsData: [
          { name: '搜索', key: 'content', value: '', type: 'text' },
          { name: '推送时间', key: 'updateTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '新增', key: 'ADD', action: 'ADD', hidden: false, className: 'primary', permission: 'ADD' },
          { name: '删除', key: 'DELETE', action: 'DELETE_LIST', hidden: false, permission: 'DELETE' }],
        formTableData: [
          { name: '内容', key: 'content', type: 'text' },
          { name: '推送时间', key: 'publishTime', type: 'text', sortable: 'custom' },
          { name: '创建人', key: 'createUserName', type: 'text' },
          { name: '创建时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '状态', key: 'isPublish', type: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true, buttonMinWidth: 200, buttonWidth: 200 }
      },
      formTableButtonsData: [{ name: '发布', key: 'PUBLISH', action: 'PUBLISH', className: 'primary', hidden: false, permission: 'PUBLISH' },
        { name: '编辑', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: false, permission: 'EDIT' },
        { name: '删除', key: 'DELETE', action: 'DELETE', className: 'danger', hidden: false, permission: 'DELETE' }]
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
    },
    toClickAction(row, item) {
      if (item.action === 'EDIT') {
        this.$store.dispatch('setMessageDetailData', row)
        this.$refs.messageTableRef.toEdit(item, row)
      } else if (item.action === 'DELETE') {
        this.$refs.messageTableRef.toDelete(item, row)
      } else if (item.action === 'PUBLISH') {
        this.$wtUtil.deleteConfirm(this, `确认发布消息？`).then(() => {
          request({
            url: '/modules/message/messagePublish',
            method: 'post',
            data: {
              id: row.id
            }
          }).then(res => {
            if (res.code === '0') {
              this.$message({ message: '发布成功', type: 'success' })
              this.$refs.messageTableRef.requestList()
            }
          })
        })
      }
    }
  }
}
</script>
<style>

</style>
